//import Moment from "moment";

const getCount = (state) => {
	return state.grupoEquipamentos.length;
}

export default {
	getCount
}